import api from '../../api'

export default {
  namespaced: true,
  state: {
    comments: {
      comments: [],
      statistic: null,
      comments_left: null,
      offset: null,
      total_count: null
    },
    commentsWithMedia: {},
    currentMediaIndex: 0,
    isLoading: false
  },
  mutations: {
    SET_COMMENTS: (state, obj) => {
      state.comments.comments = [ ...state.comments.comments, ...obj.comments ]
      state.comments.statistic = obj.statistic ?? null
      state.comments.comments_left = obj.comments_left
      state.comments.offset = obj.offset
      state.comments.total_count = obj.total_count
    },
    SET_COMMENTS_WITH_MEDIA: (state, obj) => {
      state.commentsWithMedia = obj
    },
    SET_CURRENT_MEDIA_INDEX: (state, index) => {
      state.currentMediaIndex = index
    },
    SET_IS_LOADING: (state, bool) => {
      state.isLoading = bool
    }
  },
  actions: {
    FETCH_COMMENTS: ({ commit, rootGetters }, payload) => {
      return new Promise((resolve, reject) => {
        commit('SET_IS_LOADING', true)

        api.comments.getComments(payload)
          .then(res => {
            if (res.success) {
              payload.onlyWithMedia ? commit('SET_COMMENTS_WITH_MEDIA', res) : commit('SET_COMMENTS', res)
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_IS_LOADING', false)
          })
      })
    },
    CHANGE_CURRENT_MEDIA_INDEX: ({ commit }, index) => {
      commit('SET_CURRENT_MEDIA_INDEX', index)
    },
    POST_NEW_COMMENT: ({ commit, rootGetters }, payload) => {
      return new Promise((resolve, reject) => {
        api.comments.postComment(payload)
          .then(res => {
            if (res.success) {
              resolve({ success: true, message: rootGetters.translations('comments.messages.moderation') })
            } else {
              resolve({ success: false, message: rootGetters.translations('comments.messages.error') })
            }
          })
          .catch(() => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({ success: false, message: rootGetters.translations('comments.messages.moderation') })
          })
      })
    }
  }
}
